import pkg from '../../package.json' with { type: 'json' };

export const CLI_VERSION: string = pkg.version;
